import { FC, useContext, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { FirestoreContext } from "../../context/Context";
import { NotFound } from "../../components";
import { Container, Content, Title, Type } from "./styles";


const Gem: FC = () => {
  const data = useContext(FirestoreContext);
  const { id } = useParams();
  let targetLyrical = data.lyricals.find((element) => element.id === id);

  useEffect(() => {
    const originalBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#f9f9f9";
    return () => {
      document.body.style.backgroundColor = originalBg;
    };
  }, []);

  window.scrollTo(0, 0);

  return targetLyrical ? (
    <>
      <Helmet>
        <title>{targetLyrical.title} | Truth Miner Gems</title>
        <meta name="description" content={targetLyrical.content.substring(0, 160)} />
      </Helmet>
      <Container>
        <Type> {targetLyrical.type.toUpperCase()} </Type>
        <Title> {targetLyrical.title} </Title>
        <Content dangerouslySetInnerHTML={{ __html: targetLyrical.html }} />
      </Container>
    </>
  ) : (
    <NotFound />
  );
};

export default Gem;
